"use strict";

var moduleName = "toggleBox";

module.exports = function () {
	$(".toggle-box").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);

		var $box = $(this),
			$content = $box.children('.toggle-box__content'),
			$btn = $box.children('.toggle-box__btn');

		$btn.on('click', function(){
			var $btnText = $btn.children('.toggle-box__btn-text'),
				oldBtnText = $btnText.text(),
				newBtnText = $btn.data('alt-text'),
				$wrapper;

			$content.wrap('<div class="toggle-box__wrapper"></div>');
			$wrapper = $content.parent('.toggle-box__wrapper');

			if ($box.hasClass('toggle-box_open')) {
				$wrapper.css('height', $content.outerHeight());
				setTimeout(function(){
					$wrapper.css('height', 0);
				}, 0);
				setTimeout(function(){
					$box.removeClass('toggle-box_open');
					$content.unwrap();
				}, 300);
			} else {
				$wrapper.css('height', 0);
				setTimeout(function(){
					$box.addClass('toggle-box_open');
					$wrapper.css('height', $content.outerHeight());
				}, 0);
				setTimeout(function(){
					$content.unwrap();
				}, 300);
			}

			$btnText.text(newBtnText);
			$btn.data('alt-text', oldBtnText);

			return false;
		});

	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/toggleBoxInit.js
 **/